export enum PlantStatusPageReferer {
  STATUS = 'status',
  PERFORMANCE = 'performance',
  PROCESS_ENGINEER_DASHBOARD = 'process-engineer-dashboard',
  RELIABILITY_ENGINEER_DASHBOARD = 'reliability-engineer-dashboard',
  OPTIMIZATION_SPECIALIST_DASHBOARD = 'optimization-specialist-dashboard'
}

export enum DowntimePageReferer {
  DOWNTIME = 'downtime',
  MAJOR_OUTAGE_LEAD_DASHBOARD = 'major-outage-lead-dashboard'
}

export enum KilnStatsPageReferer {
  DOWNTIME = 'downtime',
  MAJOR_OUTAGE_LEAD_DOWNTIME = 'major-outage-lead-downtime'
}
